import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class DownloadPDFService {
  links = new Map([
    ['Standard Flood Map', {path: 'assets/flood-map/sample-flood-report.pdf', filename: 'sample-flood-report.pdf'}],
    ['Premium Flood Map', {path: 'assets/flood-map/sample-premium-flood-report.pdf', filename: 'sample-premium-flood-report.pdf'}],
    ['Hazard Report', {path: 'assets/hazard/sample-hazard-report.pdf', filename: 'sample-hazard-report.pdf'}],
    ['Hazard Glossary', {path: 'assets/hazard/hazard-glossary.pdf', filename: 'hazard-glossary.pdf'}],
    ['Real Estate', {path: 'assets/community-insights/sample-real-estate-report.pdf', filename: 'sample-real-estate-report.pdf'}],
    ['Economics & Demographics', {path: 'assets/community-insights/sample-economics-and-demographics-report.pdf', filename: 'sample-economics-and-demographics-report.pdf'}],
    ['Schools Data', {path: 'assets/community-insights/sample-schools-data-report.pdf', filename: 'sample-schools-data-report.pdf'}],
    ['Trends & Forecasts', {path: 'assets/community-insights/sample-trends-and-forecasts-report.pdf', filename: 'sample-trends-and-forecasts-report.pdf'}],
    ['Building Permits', {path: 'assets/building-permits/sample-building-permits-report.pdf', filename: 'sample-building-permits-report.pdf'}],
    ['Building Sketch', {path: 'assets/building-sketch/sample-building-sketch-report.pdf', filename: 'sample-building-sketch-report.pdf'},],
    ['Assessor Map', {path: 'assets/assessor-map/sample-assessor-map-report.pdf', filename: 'sample-assessor-map-report.pdf'},],
    ['Foreclosure', {path: 'assets/foreclosure/sample-foreclosure-report.pdf', filename: 'sample-foreclosure-report.pdf'},],
    ['Document Image', {path: 'assets/document-image/sample-document-image.pdf', filename: 'sample-document-image.pdf'},],
  ]);

  public downloadPDF(title: string): void {
    const link = document.createElement('a');
    link.setAttribute('type', 'hidden');
    const fileObject = this.links.get(title);
    if (fileObject) {
      link.href = fileObject.path;
      link.download = fileObject.filename;
    }
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
}
